import React, { Dispatch, SetStateAction } from "react";
import { Auth } from "aws-amplify";
import { useTranslation } from "react-i18next";
import { NavLink, useNavigate } from "react-router-dom";
import { useContextHospi } from "context/ContextHospi";
import { hostRoutes, studentRoutes } from "routes";
import {
  HOST_CHATS_ROUTE,
  HOST_MATCHES_ROUTE,
  HOST_PROFILE_ROUTE,
  HOST_PROFILEVIEW_ROUTE,
  HOST_ROOMS_ROUTE,
  HOST_TENANTS_ROUTE,
  LOGIN_ROUTE,
  REGISTER_ROUTE,
  STUDENT_CHATS_ROUTE,
  STUDENT_MATCHES_ROUTE,
  STUDENT_PROFILE_ROUTE,
  STUDENT_PROFILEVIEW_ROUTE,
  STUDENT_ROOMS_ROUTE,
} from "utils/constants";
import { Item, StyledMenu } from "./styles";

interface IProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
}

const ProfileMenu = ({ open, setOpen }: IProps) => {
  const { t, i18n } = useTranslation('header');
  const navigate = useNavigate();
  // const {i18n} = useTranslation('header')
  const { userStatus, setUser, changeUser, userProfile, getNameUser, unreadConversations } =
    useContextHospi();

  return (
    <StyledMenu open={open}>
      {userStatus === undefined ? (
        <>
          <Item>
            <NavLink
              to={userStatus === undefined ? `/${i18n.language}${LOGIN_ROUTE.slice(5)}` : `/${i18n.language}/`}
              onClick={() => setOpen((prev) => !prev)}
            >
              {t("menu.signIn")}
            </NavLink>
          </Item>
          <Item>
            <NavLink
              to={userStatus === undefined ? `/${i18n.language}${REGISTER_ROUTE.slice(5)}` : `/${i18n.language}/`}
              onClick={() => setOpen((prev) => !prev)}
            >
              {t("menu.signUp")}
            </NavLink>
          </Item>
        </>
      ) : (
        <>
          <Item style={{ cursor: "default" }}>
            <p style={{ margin: 0 }}>{t(`subMenu.signedIn`)}</p>
            <p>{getNameUser}</p>
          </Item>
          <hr />
          {userStatus === "student" &&
            userProfile &&
            studentRoutes
              .filter((item) =>
                [
                  STUDENT_PROFILEVIEW_ROUTE,
                  STUDENT_ROOMS_ROUTE,
                  STUDENT_CHATS_ROUTE,
                  STUDENT_MATCHES_ROUTE,
                ].includes(item.path)
              )
              .map((item) => (
                <Item key={`/${i18n.language}${item.path.slice(5)}`}>
                  <NavLink
                    to={`/${i18n.language}${item.path.slice(5)}`}
                    onClick={() => {
                      setOpen((prev) => !prev);
                    }}
                  >
                    <span style={{ position: 'relative' }}>{t(`subMenu.${item.keyLocalize}`)}
                      {
                        (item.keyLocalize === 'chats' && unreadConversations.length) ? <div style={{ position: 'absolute', top: 'calc(50% - 2.5px)', right: '-20px', width: 8, height: 8, borderRadius: '50%', background: '#032565' }} /> : ''
                      }
                    </span>
                  </NavLink>
                </Item>
              ))}
          {userStatus === "host" &&
            userProfile &&
            hostRoutes
              .filter((item) =>
                [
                  HOST_PROFILEVIEW_ROUTE,
                  HOST_ROOMS_ROUTE,
                  HOST_MATCHES_ROUTE,
                  HOST_CHATS_ROUTE,
                  HOST_TENANTS_ROUTE,
                ].includes(item.path)
              )
              .map((item) => (
                <Item key={`/${i18n.language}${item.path.slice(5)}`}>
                  <NavLink
                    to={`/${i18n.language}${item.path.slice(5)}`}
                    onClick={() => setOpen((prev) => !prev)}
                  >
                    <span style={{ position: 'relative' }}>{t(`subMenu.${item.keyLocalize}`)}
                      {
                        (item.keyLocalize === 'chats' && unreadConversations.length) ? <div style={{ position: 'absolute', top: 'calc(50% - 2.5px)', right: '-20px', width: 8, height: 8, borderRadius: '50%', background: '#032565' }} /> : ''
                      }
                    </span>
                  </NavLink>

                </Item>
              ))}
          {["student", "host"].includes(userStatus) && !userProfile && (
            <Item>
              <NavLink
                to={`${userStatus === "host"
                    ? `/${i18n.language}${HOST_PROFILE_ROUTE.slice(5)}`
                    : `/${i18n.language}${STUDENT_PROFILE_ROUTE.slice(5)}`
                  }`}
                onClick={() => setOpen((prev) => !prev)}
              >
                {t(`subMenu.profile`)}
              </NavLink>
            </Item>
          )}
          <hr />
          <Item
            onClick={() => {
              Auth.signOut({ global: true }).finally(() => {
                setUser(undefined);
                changeUser(undefined);
              });
              setOpen((prev) => !prev);
              navigate(`/${i18n.language}/`);
            }}
          >
            {t(`subMenu.signOut`)}
          </Item>
        </>
      )}
    </StyledMenu>
  );
};
export default ProfileMenu;
